import { create } from 'zustand';
import type { LibSubscription } from 'lib/billing/pbAdapter';

export type LeaveRequest = {
  /** Cancelled whole, each at the end of its paid period. */
  subscriptions: LibSubscription[];
  /** For a page that keeps its own copy of what was cancelled, outside the billing store. */
  onCancelled?: () => void;
};

type LeaveDialogState = {
  /** `key` remounts the dialog per opening, so every visit starts clean. */
  request: (LeaveRequest & { key: number }) | null;
  open: (request: LeaveRequest) => void;
  close: () => void;
  /**
   * Cancelled in this session. Billing writes the end date only when Stripe's webhook lands, after the
   * refresh that follows a cancel, so without this a plan cancelled a moment ago still looks running.
   */
  endingIds: string[];
  markEnding: (ids: string[]) => void;
  /** A resumed plan runs on again. */
  unmarkEnding: (id: string) => void;
};

let openings = 0;

/** The one cancellation dialog: any screen whose cancel ends the customer's last plan opens it here. */
export const useLeaveDialog = create<LeaveDialogState>()((set) => ({
  request: null,
  open: (request) => {
    openings += 1;
    set({ request: { ...request, key: openings } });
  },
  close: () => set({ request: null }),
  endingIds: [],
  markEnding: (ids) => set((state) => ({ endingIds: Array.from(new Set([...state.endingIds, ...ids])) })),
  unmarkEnding: (id) => set((state) => ({ endingIds: state.endingIds.filter((ending) => ending !== id) }))
}));
